import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { ConfirmEmailScreen } from '../screens/ConfirmEmailScreen';
import { ForgotPasswordScreen } from '../screens/ForgotPasswordScreen';
import { PasswordChangeScreen } from '../screens/PasswordChangeScreen';
import { RequestAccountDeletionScreen } from '../screens/RequestAccountDeletionScreen';
import { SigninScreen } from '../screens/SigninScreen';
import { SignupScreen } from '../screens/SignupScreen';
import { PendingEmailConfirmationScreen } from '../screens/PendingEmailConfirmationScreen';
import { WelcomeScreen } from '../screens/WelcomeScreen';
import { stackHeaderTitleStyle } from '../theme';
const Stack = createNativeStackNavigator();
/**
 * Guest nav typically consists of screens where the user is logged out.
 */
export const GuestNav = () => {
    return (<Stack.Navigator screenOptions={{
            headerShown: false,
            headerTitleStyle: stackHeaderTitleStyle,
        }}>
      <Stack.Screen name="Signin" component={SigninScreen}/>
      <Stack.Screen name="Signup" component={SignupScreen}/>
      <Stack.Screen name="Welcome" component={WelcomeScreen}/>
      <Stack.Screen name="PendingEmailConfirmation" component={PendingEmailConfirmationScreen}/>
      <Stack.Screen name="ConfirmEmail" component={ConfirmEmailScreen}/>
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} options={{ title: 'Forgot password', headerShown: true }}/>
      <Stack.Screen name="RequestAccountDeletion" component={RequestAccountDeletionScreen} options={{ title: 'Request account deletion', headerShown: true }}/>
      <Stack.Screen name="PasswordChange" component={PasswordChangeScreen} options={{ title: 'Set new password', headerShown: true }}/>
    </Stack.Navigator>);
};
